import React, { useEffect, useState } from 'react';
import { DotPaginationProps } from './types';

const DotPagination: React.FC<DotPaginationProps> = (props) => {
  const [activePage, setActivePage] = useState<number>(0);
  const [totalPage, setTotalPage] = useState<number>(0);

  /**
   * @description 計算總頁數
   */
  useEffect(() => {
    const page = Math.ceil(props.totalCount / props.pageSize);
    setTotalPage(page);
  }, [props.totalCount, props.pageSize]);

  /**
   * @description 處理頁碼按鈕 onClick 執行的事件
   * @param pageIndex 分頁 index
   */
  const handlePageClick = (pageIndex: number) => {
    setActivePage(pageIndex);
    if (props.onChange) props.onChange(pageIndex);
  };

  return (
    <div className="dotPagination">
      {Array(totalPage)
        .fill(1)
        .map((_, buttonIndex) => {
          return (
            <div key={`page-${buttonIndex + 1}`} className="node">
              {buttonIndex > 0 ? (
                <div className="decoraction">
                  <div className="dot" />
                  <div className="dot" />
                  <div className="dot" />
                </div>
              ) : (
                []
              )}
              <button
                type="button"
                className={'page-dot' + (activePage === buttonIndex ? ' active' : '')}
                onClick={() => {
                  handlePageClick(buttonIndex);
                }}
                title={`page${buttonIndex + 1}`}
              >
                <div className="dot" />
              </button>
            </div>
          );
        })}
    </div>
  );
};

export default DotPagination;
